import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from "antd";
// Per-row widths vary to mimic real invoice name/plan length diversity.
const ROWS = [
    {
        name: 220,
        plan: 68
    },
    {
        name: 320,
        plan: 68
    },
    {
        name: 200,
        plan: 68
    },
    {
        name: 220,
        plan: 68
    },
    {
        name: 160,
        plan: 56
    }
];
const InvoicesSkeleton = ()=>/*#__PURE__*/ _jsx("div", {
        className: "rc-account-v2-invoice-card",
        "aria-busy": "true",
        "aria-live": "polite",
        "aria-label": "Loading invoices",
        children: ROWS.map(({ name, plan }, i)=>/*#__PURE__*/ _jsxs("div", {
                className: "rc-account-v2-invoice-row",
                "aria-hidden": true,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "rc-account-v2-invoice-row__logo",
                        children: /*#__PURE__*/ _jsx(Skeleton.Avatar, {
                            active: true,
                            shape: "square",
                            size: 48,
                            style: {
                                borderRadius: 8
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "rc-account-v2-invoice-row__info",
                        children: [
                            /*#__PURE__*/ _jsx(Skeleton.Input, {
                                active: true,
                                size: "small",
                                style: {
                                    width: name,
                                    height: 15
                                }
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                style: {
                                    marginTop: 3
                                },
                                children: /*#__PURE__*/ _jsx(Skeleton.Input, {
                                    active: true,
                                    size: "small",
                                    style: {
                                        width: plan,
                                        height: 12
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "rc-account-v2-invoice-row__meta",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "rc-account-v2-invoice-row__meta-col",
                                children: [
                                    /*#__PURE__*/ _jsx(Skeleton.Input, {
                                        active: true,
                                        size: "small",
                                        style: {
                                            width: 48,
                                            height: 12
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        style: {
                                            marginTop: 3
                                        },
                                        children: /*#__PURE__*/ _jsx(Skeleton.Input, {
                                            active: true,
                                            size: "small",
                                            style: {
                                                width: 38,
                                                height: 14
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "rc-account-v2-invoice-row__meta-col",
                                children: [
                                    /*#__PURE__*/ _jsx(Skeleton.Input, {
                                        active: true,
                                        size: "small",
                                        style: {
                                            width: 24,
                                            height: 12
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        style: {
                                            marginTop: 3
                                        },
                                        children: /*#__PURE__*/ _jsx(Skeleton.Input, {
                                            active: true,
                                            size: "small",
                                            style: {
                                                width: 46,
                                                height: 14
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "rc-account-v2-invoice-row__actions",
                        children: [
                            /*#__PURE__*/ _jsx(Skeleton.Button, {
                                active: true,
                                size: "small",
                                style: {
                                    width: 84
                                }
                            }),
                            /*#__PURE__*/ _jsx(Skeleton.Button, {
                                active: true,
                                size: "small",
                                style: {
                                    width: 120
                                }
                            })
                        ]
                    })
                ]
            }, i))
    });
export { InvoicesSkeleton };
